import { Vector2, Vector3 } from 'three';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  RGBImage2,
  GrayImage2,
  GrayImage3,
} from '../../image-slice-show/share/image';

export function dummyRGBImage(size: Vector2, shape: Vector2) {
  const nbPixels = shape.x * shape.y;
  const r = new Uint8Array(nbPixels);
  const g = new Uint8Array(nbPixels);
  const b = new Uint8Array(nbPixels);
  for (let i = 0; i < shape.x; i++) {
    for (let j = 0; j < shape.y; j++) {
      const y = Math.sin((i / shape.x) * Math.PI * 2 + Math.PI / 4);
      const x = Math.cos((j / shape.y) * Math.PI * 2);
      const v = (x * y + 1) / 2;
      r[i * shape.y + j] = v * 255;
      g[i * shape.y + j] = v * 255;
      b[i * shape.y + j] = v * 255;
    }
  }
  return new RGBImage2(new Vector2(0, 0), size, shape, r, g, b);
}

export function dummyGrayImage(size: Vector2, shape: Vector2) {
  const nbPixels = shape.x * shape.y;
  const data = new Float32Array(nbPixels);
  for (let i = 0; i < shape.x; i++) {
    for (let j = 0; j < shape.y; j++) {
      const y = Math.sin((i / shape.x) * Math.PI * 2 + Math.PI / 4);
      const x = Math.cos((j / shape.y) * Math.PI * 2);
      const v = (x * y + 1) / 2;
      data[i * shape.y + j] = v * 255;
      // console.log(v);
    }
  }
  return new GrayImage2(new Vector2(0, 0), size, shape, data);
}

export function dummyGrayImage3(size: Vector3, shape: Vector3) {
  const nbPixels = shape.x * shape.y * shape.z;
  const data = new Float32Array(nbPixels);
  for (let i = 0; i < shape.x; i++) {
    for (let j = 0; j < shape.y; j++) {
      for (let k = 0; k < shape.z; k++) {
        const y = Math.sin(
          (i / shape.x) * Math.PI * 2 + (Math.PI * k) / shape.z,
        );
        const x = Math.cos((j / shape.y) * Math.PI * 2);
        const v = (x * y + 1) / 2;
        data[i * shape.y * shape.z + j * shape.z + k] = v;
      }
    }
  }
  return new GrayImage3(new Vector3(0, 0, 0), size, shape, data);
}

export function sequenceDummyGrayImage2(
  size: Vector2,
  shape: Vector2,
  center: Vector2,
  next$: Observable<void>,
) {
  return next$.pipe(
    map(
      () =>
        new GrayImage2(
          center,
          size,
          shape,
          new Float32Array(shape.x * shape.y).fill(Math.random()),
        ),
    ),
  );
}
